<template>
    <defs>
        <mask id="SVGnNgsclOC">
            <g fill="none">
                <path
                    fill="#fff"
                    d="M14.667 8c0 3.682-2.985 6.667-6.667 6.667S1.333 11.682 1.333 8S4.318 1.333 8 1.333s6.667 2.985 6.667 6.667"
                /><path
                    fill="#000"
                    fill-rule="evenodd"
                    d="M8 4.833a.5.5 0 0 1 .5.5v2.46l1.52 1.52a.5.5 0 1 1-.707.707l-1.667-1.667a.5.5 0 0 1-.146-.353V5.333a.5.5 0 0 1 .5-.5"
                    clip-rule="evenodd"
                />
            </g>
        </mask>
    </defs><path
        fill="currentColor"
        d="M0 0h16v16H0z"
        mask="url(#SVGnNgsclOC)"
    />
</template>
